import React from 'react';
import colors from '@general/colors';
import fonts from '@general/fonts';

export default function Tab({ children, active = false, onClick }) {
    const style = {
        border: 'none',
        backgroundColor: 'transparent',
        borderBottomStyle: 'solid',
        borderBottomWidth: 6,
        cursor: 'pointer',
        borderBottomColor: active ? colors.primary : 'transparent',
        fontWeight: 900,
        fontSize: '1.25rem',
        paddingBottom: '0.75rem',
        fontFamily: fonts.sans,
        display: 'flex',
        alignItems: 'center',
    };

    return (
        <button onClick={onClick} style={style}>
            {children}
        </button>
    );
}
